import { render, staticRenderFns } from "./DirCharts.vue?vue&type=template&id=f342b7a4&scoped=true&"
import script from "./DirCharts.vue?vue&type=script&lang=js&"
export * from "./DirCharts.vue?vue&type=script&lang=js&"
import style0 from "./DirCharts.vue?vue&type=style&index=0&id=f342b7a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f342b7a4",
  null
  
)

export default component.exports